import React from "react";
import { graphql } from "react-relay";

import { useMutationPromise } from "~/lib/relayUtil";

import type { ShareModal_updateRecordingVisibilityMutation as UpdateRecordingVisibilityMutation } from "~/__generated__/ShareModal_updateRecordingVisibilityMutation.graphql";

const VISIBILITY_LEVELS = ["PRIVATE", "WORKSPACE", "PUBLIC"] as const;
type Visibility = (typeof VISIBILITY_LEVELS)[number];

export function useVisibilityChangeMutation() {
	const [commit, isInFlight] = useMutationPromise<UpdateRecordingVisibilityMutation>(graphql`
		mutation ShareModal_updateRecordingVisibilityMutation($noteId: ID!, $visibility: MeetingRecordingVisibility!)
		@raw_response_type {
			updateMeetingRecordingVisibility(noteId: $noteId, visibility: $visibility) {
				note {
					id
					meetingRecordingLink {
						id
						visibility
					}
				}
			}
		}
	`);

	const changeVisibility = React.useCallback(
		async (noteId: string, visibility: Visibility, meetingRecordingLinkId: string) => {
			await commit({
				variables: { noteId: noteId, visibility },
				optimisticResponse: {
					updateMeetingRecordingVisibility: {
						note: {
							id: noteId,
							meetingRecordingLink: { id: meetingRecordingLinkId, visibility },
						},
					},
				},
			});
		},
		[commit],
	);

	return [changeVisibility, isInFlight] as const;
}
